import axios from 'axios';
import { i18n } from '@/i18n';

export default {
  data() {
    return {
      sendSmsUrl: '',
      totalCountdownTime: 60,
      btnSMScontent: i18n.global.t('login.REGISTER.sendsmscode'),
      sendCodeError: false,
      sendCodeMessage: true,
    };
  },
  methods: {
    validateMobile(rule, value, callback) {
      if (value === '') {
        callback(new Error(i18n.global.t('login.REGISTER.inputmobile')));
      } else {
        const reg =
          /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
        if (!reg.test(value)) {
          callback(
            new Error(i18n.global.t('login.REGISTER.inputcorrectmobile')),
          );
        } else {
          callback();
        }
      }
    },
    setCountdown() {
      let clock = window.setInterval(() => {
        this.btnSMScontent = this.totalCountdownTime + 's后重新发送';
        this.totalCountdownTime--;
        if (this.totalCountdownTime < 0) {
          this.totalCountdownTime = 60;
          this.btnSMScontent = '重新发送验证码';
          window.clearInterval(clock);
        }
      }, 1000);
    },

    //获取登录验证码
    async sendSMSCode() {
      let isValid = false;
      await this.$refs.form.validateField('mobile', (valid, _invalidFields) => {
        isValid = valid;
      });
      if (!isValid) return;
      const baseURL = process.env.VUE_APP_MAPSCLOUD_AUTH_SERVER;
      const reqConf = {
        method: 'POST',
        baseURL,
        url: this.sendSmsUrl,
        data: {
          mobile: this.model.mobile,
        },
      };
      try {
        this.sendCodeError = false;
        this.sendCodeMessage = null;
        const { data } = await axios(reqConf);
        if (data.status == 0) {
          this.setCountdown();
        } else {
          this.sendCodeError = true;
          this.sendCodeMessage = data.message;
        }
      } catch (err) {
        this.sendCodeError = true;
        console.error(err);
      }
    },
  },
};
